import t from '@jetshop/intl';
import { ErrorMessage, Field } from 'formik';
import React from 'react';
import { styled } from 'linaria/react';
import { InputError, InputPositive } from '../../Forms/InputStatus';
import { useEffect } from 'react';
import { theme } from '../../Theming/Theming';

export const Input = styled('input')`
  height: 50px;
  background: #fff;
  border: 1px solid #ccc;
  padding: 10px;
  width: 100%;
  margin-bottom: 0.25rem;
  padding-right: 40px;
  &[disabled] {
    background: #f1f1f1;
    border-color: #ddd;
  }
`;

export const Wrapper = styled('div')`
  margin-bottom: 1.5rem;
`;

export const ErrorSpan = styled('span')`
  font-style: italic;
  font-size: 12px;
  color: #ff0000;
  position: absolute;
`;

export const Label = styled('label')`
  display: block;
  font-size: 12px;
  margin-bottom: 0.25rem;
  display: block;
  font-weight: ${theme.weights.bold};
  .req {
    color: hsl(0, 0%, 60%);
    margin-left: 0.5em;
  }
  &[data-disabled='true'] {
    color: #808080;
  }
`;

const InputWrapper = styled('div')`
  position: relative;
`;

const InputComp = ({
  newValue,
  setFieldValue,
  disabled,
  props,
  field,
  maxLength,
  disableValidation,
  touched,
  errors
}) => {
  const name = field.name;
  useEffect(() => {
    if (typeof newValue !== 'undefined') setFieldValue(name, newValue);
  }, [newValue, setFieldValue, name]);
  return (
    <InputWrapper>
      <Input
        disabled={disabled}
        {...props}
        {...field}
        type={'text'}
        maxLength={maxLength}
      />
      {!disableValidation && (
        <>
          {touched?.field?.name && errors?.field?.name && <InputError />}
          {touched?.field?.name && !errors?.field?.name && <InputPositive />}
        </>
      )}
    </InputWrapper>
  );
};

const CommentInput = ({
  label,
  disabled,
  error,
  success,
  warning,
  loading,
  name,
  required,
  type,
  newValue,
  disableValidation,
  maxLength = 9999,
  ...props
}) => {
  return (
    <Wrapper className={props.wrapperClassName}>
      <Label data-disabled={disabled} htmlFor={name}>
        <span>{label || name}</span>
        {required && <span className="req">{t('(Required)')}</span>}
      </Label>
      <Field
        data-disabled={disabled}
        id={name}
        name={name}
        render={({ field, form: { touched, errors, setFieldValue } }) => {
          return (
            <InputComp
              {...{
                setFieldValue,
                disabled,
                newValue,
                props,
                field,
                maxLength,
                disableValidation,
                touched,
                errors
              }}
            />
          );
        }}
      />
      {!disableValidation && <ErrorMessage name={name} component={ErrorSpan} />}
    </Wrapper>
  );
};

export default CommentInput;
